/**
 * TestingItemRow — one lander/offer under its path, on the shared grid template.
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC } from 'react';
import { CornerDownRight } from 'lucide-react';
import type { QueueElement } from '@trafficpulse/shared';

import type { QueueProvider } from '@/features/trackers/flow-optimizer/queue-provider';
import QueueTimelineCell from '../../../timeline/QueueTimelineCell';
import { Cell, COLUMN_LABELS, GridRow } from '../testing-grid';
import NextRunCell, { rowTone, type NextRunCellProps } from './NextRunCell';
import { ElementIdentity, RunsBadge, TestedFor } from './testing-row-bits';

export interface TestingItemRowProps extends NextRunCellProps {
  el: QueueElement;
  campaignId: string;
  provider: QueueProvider;
}

const TestingItemRow: FC<TestingItemRowProps> = ({
  el,
  swap,
  held,
  campaignId,
  provider,
}) => (
  <GridRow tone={rowTone({ swap, held })} className="hover:bg-muted/40">
    <Cell className="pl-3">
      <CornerDownRight className="h-3 w-3 shrink-0 text-muted-foreground/60" aria-hidden />
      <ElementIdentity el={el} />
      <RunsBadge el={el} />
    </Cell>
    <Cell label={COLUMN_LABELS.underTest}>
      <TestedFor el={el} />
    </Cell>
    <Cell label={COLUMN_LABELS.nextRun}>
      <NextRunCell swap={swap} held={held} />
    </Cell>
    {/* Actions are per-PATH only — landers/offers cannot be moved off the
        tracker on their own, so this keeps the columns aligned. */}
    <Cell>{null}</Cell>
    <Cell align="right">
      <QueueTimelineCell element={el} campaignId={campaignId} provider={provider} />
    </Cell>
  </GridRow>
);

export default TestingItemRow;
